<template lang="pug">
//- 超级会员老版 未开卡页
.main
  .super-container(:style='topStyle')
    common-header.header(
      v-if="env.isEasyBikeApp&&haveData"
      color="#242729",
      title="",
      ref="header",
      left-black-when-active,
      left-black-when-inactive,
      :leftFlex="0.5"
      :isBackClose="false"
    )
      template(slot='left')
        .top-left-line
      template(slot="right")
        .header-menu(@click="rule")
    .haveData(v-if="haveData")
      .ladder-have-test()
        ladderTest(
          :isNewType="false",
          :groupList="groups"
          :zeroBuyCardShow="zeroBuyCardShow"
          :ladderDetailMap="ladderDetailMap"
          :ladderPropGroupList="ladderPropGroupList"
          :goodsList="goodsList"
          :newCustomer="newCustomer"
          :showStyleVersion="showStyleVersion"
          :showAppExpensive="showAppExpensive"
          :version="propVersion"
          :buyingAdviceAB="buyingAdviceAB"
          :cardPurchase="cardPurchaseSuggestionDTO"
          :bikeCardShowStyle="bikeCardShowStyle"
          :isAppVip="isAppVip"
          @ladderEasyTab="changeLadderEasy"
          @aggData="getAggData"
          @chooseIndex="getChooseIndex"
          @errorPage="showError"
        )
        .other-block-test
          .other-block-item(
            v-for="(item, index) in otherList",
            @click="openCommonBonus(item,true,index + groupsOther.length+testSecondList.length)"
          )
            .other-title-img()
              .top-sign {{getSignleImg(index)}}
            img.under-img(:src="item.bonusEntity.unPayImage")
        nba-super-card(@openModal="openNbaModal" :vipData="vipData")
        .bikeMonthCard(v-if="propVersion ==='ride_trial'&&currentRideCard&&zeroBuyCardShow")
          .card-top
            .icon
              img(src="https://m.hellobike.com/resource/helloyun/22871/sQNgk_Group%20576.png")
            .text 单车骑行月卡
          .card-bottom
            .left
              span.topContext 单车{{currentRideCard.useProperty.totalCardDays}}天不限次卡·生效中
              span.botContext 本月已有单车卡，到期自动续
            .right
              span 剩
              span.font  {{currentRideCard.remainDays}}
              span 天
        .no-use(v-if="fullRefundUnusedShowAb" @click="showNoUse")
          .no-use-left
            img.no-use-img(src="https://m.hellobike.com/resource/gallery/61/1L7fasp87l.png?x-oss-process=image/quality,q_80")
            div 未使用包退
          .no-use-right(@click="showNoUse")
            span 查看
            img.no-use-flag(src="https://m.hellobike.com/resource/gallery/61/ZPRWm4DbLm.png?x-oss-process=image/quality,q_80")
        qaAndSuggest(:showQa="showQa" @goQa="goQa" @goSuggest="goSuggest")
        .rule-block(v-if="!env.isEasyBikeApp" @click="rule") 规则 | 协议
        .shark-block
    .noData(v-else)
      .noData-img
        img.nodata-gif(
          src="https://m.hellobike.com/resource/helloyun/08345/ptrfD33uJv.webp"
        )
      .noData-word 即将进入超级会员…
    vipButtonLadder(
      v-if="haveData&&!currentRideCard"
      ref="buttonNew",
      :info="price",
      :readSign="isRead"
      @open="bayCardHandler",
      @openDialog="openDialog",
      @transTab="getTransTab",
      @isNoReadSign="openRead"
      :time="price.couponEndTime || 0"
      :unOpenShowCanBuy="unOpenShowCanBuy"
      :isIndex="true"
      :giftList="giftList"
      :propVersion="propVersion"
    )
    vipButtonZeroBuy(
      v-if="haveData&&currentRideCard"
      ref="buttonNew",
      :info="price",
      :readSign="isRead"
      :currentRideCard="currentRideCard"
      @open="bayCardHandler",
      @openDialog="openDialog",
      @transTab="getTransTab",
      @isNoReadSign="openRead"
      @priceChange="priceChange"
      :time="price.couponEndTime || 0"
      :unOpenShowCanBuy="unOpenShowCanBuy"
      :isIndex="true"
    )
    tip-modal(
      ref="tipModal",
      :mainTitle="mainTipTitle",
      :subTitle="subTipTitle"
      @goRenewalPage="goCardComplete"
    )
    RetainModal(
      ref="retain",
      :commonBonus="commonBonus",
      :save="save",
      :transPrice="transPrice",
      :transType="transType",
      @confirm="bayCardHandler",
      @cancel="goBack",
      @close="closeScroll"
    )
    appPrivilegeSuccess(
      :show.sync="showAppPrivilege"
      @goUrl="goUrl(config.deepLink,true)"
      @close="goCardComplete")
    feedback-popup(
    v-if="showFeedback"
    :show.sync="showFeedback"
    @close="closeScroll"
    @submit="feedbackSubmit")
    CompletedModal(
      ref="complete",
      @confirm="goCardComplete",
      :amount="save",
      :commonBonus="commonBonus",
      @close="goCardComplete"
    )
    onePageUpModal(
      ref="onepageup",
      @transTab="getTransTab",
      :type="1",
      :info="price",
      :time="price.couponEndTime || 0",
      :autoRenewalStatus="autoRenewalStatus",
      @closeOnePage="closeScroll",
      @openDialog="openDialog",
      @open="bayCardHandler",
      :commonBonus="commonBonus"
      :unOpenShowCanBuy="unOpenShowCanBuy"
      :showStyleVersion="showStyleVersion"
    )
    readModal.read-modules(
      :show="showRead"
      @close="showRead=false"
      @readOk="readOk"
    )
    noUseBlock(
      :show.sync="showNoUseBolck"
    )
    visit-page-countdown(
      :env="Env"
    )
    nba-card-modal(
      :show.sync="nbaShow"
      :info="nbaPrice",
      :readSign="isRead"
      :time="nbaPrice.couponEndTime || 0"
      :unOpenShowCanBuy="unOpenShowCanBuy"
      :isIndex="true"
      :giftList="giftList"
      :propVersion="propVersion"
      @open="bayCardHandler",
      @openDialog="openDialog",
      @transTab="getTransTab",
      @isNoReadSign="openRead"
    )
</template>

<script>
import '@hb/task-h5-components/lib/countdown/visit-page';
import {
  getSuperVipGoods,
  buyVipGoods,
  tryTakeOrderStatus,
  getWaitPayOrder,
  closeVipGoods,
  showQa,
  submitFeedback,
  aggGoods,
} from '@/api/vip';
import config from '@/const/config';
import CommonHeader from '@/components/common-middle-header';
import { Native, env } from '@hb/hbridge';
// import { getVipBiz } from '@/utils/vip';
import Loading from '@/components/loading';
import Lottie from '@/components/lottie';
import {
  getTokenAndLocation,
  isPreRender,
  getNoScroll,
} from '@/utils';
import Toast from '@/components/toast';
// import Cashier from '@hb/h5-cashier';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import OpenSkeleton from '@/components/skeleton.vue';
import { CardService } from '@/service/card';
import { Storage } from '@/utils/storage';
import Picture from '@/components/picture';
import { startApp } from '@/utils/index';
import { Navigator } from '@hb/h5-navigator';
import { PropVersionMap } from '@/const/vip';
import CouponMore from './components/coupon-more.vue';
import { getSource, getTokenAndKey } from '../../../utils';
import { ParamsUtil } from '../../../utils/params';
import { getSystemCode } from '../../../utils/systemCode';
import { ORDER_STATUS, RENEWAL_STATUS, ORDER_TYPE } from '../consts';
import { UBTUtils } from '../../../utils/ubt';
import VipButtonNew from './components/vip-button-new.vue';
import VipButton from './components/vip-button.vue';
import TipModal from './components/tip-modal.vue';
import RetainModal from './components/retain-modal';
import noPay from './components/noPay';
import CompletedModal from './components/completed-modal';
import onePageUpModal from './components/one-page-up-modal';
import unOpenLineOne from './components/unopen-line-one.vue';
import readModal from './components/read-modal';
import vipButtonLadder from './components/vip-button-ladder.vue';
import vipButtonZeroBuy from './components/vip-button-zero-buy.vue';
import ladderTest from './components/ladderTest.vue';
import expansionCss from './components/expansion-css.vue';
import appPrivilegeSuccess from './components/app-privilege-success.vue';
import { filterNoOpenData } from './utils';
import noUseBlock from './components/no-use-block.vue';
import feedbackPopup from './components/feedback-popup';
import { clientSDK } from '../../../utils/wisdomSDK';
import qaAndSuggest from './components/qa-and-suggest.vue';
import nbaSuperCard from './components/new-member/nba-unopen-card.vue';
import nbaCardModal from './components/new-member/nba-card-modal.vue';

export default {
  components: {
    CommonHeader,
    OpenSkeleton,
    VipButtonNew,
    TipModal,
    RetainModal,
    noPay,
    CompletedModal,
    Lottie,
    CouponMore,
    onePageUpModal,
    unOpenLineOne,
    readModal,
    vipButtonLadder,
    vipButtonZeroBuy,
    ladderTest,
    Picture,
    expansionCss,
    appPrivilegeSuccess,
    noUseBlock,
    VipButton,
    feedbackPopup,
    qaAndSuggest,
    nbaSuperCard,
    nbaCardModal,
  },
  data() {
    return {
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true&chInfo=ch_share__chsub_CopyLink&fxzjshareChinfo=ch_share__chsub_CopyLink&apshareid=DAEF5627-8D33-4E6E-9CE2-2A0FD137329B&shareBizType=mrfxzw',
        wechatLink: 'https://m.hellobike.com/mf/spa/u_sxnpet/latest/MA2412037285359647643402840.html?activityCode=MA2412037285359647643402840',
      },
      showRenwal: true,
      zeroBuyCardShow: true,
      nbaShow: false,
      groupsImg: {
      // 图标从2开始到12
        0: 'https://m.hellobike.com/resource/helloyun/08345/-NHsfkya05.png?x-oss-process=image/quality,q_80',
        1: 'https://m.hellobike.com/resource/helloyun/08345/aNwr6P6ULZ.png?x-oss-process=image/quality,q_80',
        2: 'https://m.hellobike.com/resource/helloyun/08345/yXOKdxkN7O.png?x-oss-process=image/quality,q_80',
        3: 'https://m.hellobike.com/resource/helloyun/08345/pgpx2VpqgU.png?x-oss-process=image/quality,q_80',
        4: 'https://m.hellobike.com/resource/helloyun/08345/KYyQMmp377.png?x-oss-process=image/quality,q_80',
        5: 'https://m.hellobike.com/resource/helloyun/08345/UEELhqeUwU.png?x-oss-process=image/quality,q_80',
        6: 'https://m.hellobike.com/resource/helloyun/08345/dhRLFdh04M.png?x-oss-process=image/quality,q_80',
        7: 'https://m.hellobike.com/resource/helloyun/08345/HxY3syyCxt.png?x-oss-process=image/quality,q_80',
        8: 'https://m.hellobike.com/resource/helloyun/08345/AogXsI3ShR.png?x-oss-process=image/quality,q_80',
        9: 'https://m.hellobike.com/resource/helloyun/08345/5gCyCSmrD4.png?x-oss-process=image/quality,q_80',
        10: 'https://m.hellobike.com/resource/helloyun/08345/9zQDtozRGZ.png?x-oss-process=image/quality,q_80',
      },
      json: 'https://m.hellobike.com/resource/helloyun/08345/3ZiD4EFLNW.json',
      otherList: [],
      groups: [],
      commonBonus: [],
      save: '-',
      isNba: false,
      vipData: {},
      price: {
        goodsGuid: '',
        current: '',
        original: '39.9',
        days: 30,
        couponEndTime: 0,
        showPopUpWindowType: 0,
        signInfoDTO: {},
      },
      nbaPrice: {
        goodsGuid: '',
        current: '',
        original: '39.9',
        days: 30,
        couponEndTime: 0,
        showPopUpWindowType: 0,
        signInfoDTO: {},
      },
      willRetain: false, // 设置了挽留弹窗
      otherTotal: null,
      centerTitleLift: '',
      retainCoupon: {
        title: '-',
        subtitle: '-',
        amount: '-',
        centerTitleRight: '',
      },
      cashier: null,
      envValue: process.env.VUE_APP_ENV,
      groupsClass: {
        radius: false,
      },
      //    showAliNew: false,
      env,
      Env: config.env,
      topStyle: '',
      showNopay: false,
      noPayData: {},
      mainTipTitle: '',
      subTipTitle: '',
      transType: 30,
      transPrice: 0,
      autoRenewalStatus: RENEWAL_STATUS.unavailable,
      RENEWAL_STATUS,
      groupsOne: [],
      groupsOther: [],
      haveData: false,
      testSecondList: {
        length: 0,
      },
      taurusTaskUnOpenShowSort: '', // 未开卡展示位置
      newUserImg: 'https://m.hellobike.com/resource/helloyun/08345/nLPo8mrlc1.png',
      oldUserImg: 'https://m.hellobike.com/resource/helloyun/08345/m2s22TpfYq.png',
      propVersion: 'ladder',
      newCustomer: true,
      groupList: [],
      ladderDetailMap: null,
      ladderPropGroupList: null,
      unOpenShowCanBuy: false,
      showRead: false,
      isRead: false,
      showQa: false,
      showStyleVersion: 'ladderEasy',
      goodsList: [], // 阶梯简版列表
      ladderTab: 0, // 阶梯切换tab
      groupLadderList: [], // 阶梯简版右侧卡券数据
      // unOpenPageShowStyle: null,
      showAppPrivilege: false,
      showAppExpensive: false, // 是不是膨胀券app版本
      currentRideCard: null, // 骑行体验卡卡数据
      showNoUseBolck: false, // 未使用退款说明弹窗
      fullRefundUnusedShowAb: false, // 未使用包退说明
      closeBuyTime: null,
      buyingAdviceAB: null,
      cardPurchaseSuggestionDTO: {},
      taskCode: '',
      showFeedback: false,
      bikeCardShowStyle: null, // 单车助力车卡样式
      giftList: null,
      unOpenCouponGameAB: false,
      aggCardList: [],
      aggList: [],
      anchoredVersion: null,
      chooseIndex: 0,
      isAppVip: false,
      signPayChannels: [],
      payChannel: '',
      payActivityInfo: {},
      payingFlag: false, // 正在支付标识符
      curloopIntervalSecond: 0, // 轮询计数器
      orderTimer: null, // 轮询定时器引用
    };
  },
  provide() {
    return {
      getPropVersion: () => this.propVersion,
      unOpenCouponGameAB: () => this.unOpenCouponGameAB,
      getSignPayChannels: () => this.signPayChannels || [],
      freeRightsVersion: () => false, // 提供给子组件,仅兜底
      rideOneCentVersion: () => '',
      newH5Version: () => false, // 我的页改版,仅兜底
      latestTabCode: () => 'bike', // 我的页改版,默认tabCode,仅兜底
    };
  },
  beforeRouteEnter(to, form, next) {
    UBT.pageView({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      businessInfo: {
        adsource: getSource(),
      },
    });
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_newrules',
      contentId: 'platform_newrules',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
    // eslint-disable-next-line no-console
    console.log('页面进入');
  },
  beforeRouteLeave(to, form, next) {
    UBT.pageViewOut({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
  },
  computed: {
    sloganText() {
      const {
        centerTitleLift: left,
        retainCoupon: { centerTitleRight: right },
      } = this;
      if (left || right) {
        return `${!left ? '' : left}  ${!right ? '' : right}`;
      }
      return '骑车3次回本  打车1单必赚';
    },
    getBottom() {
      if (this.autoRenewalStatus === RENEWAL_STATUS.unavailable) {
        return 'height: 1.04rem; width: 100vw';
      }
      return 'height: 2.09rem; width: 100vw';
    },
  },
  watch: {
    'price.current': (newV) => {
      UBT.pageView({
        pageId: 'platform_savemoneycard_page',
        categoryId: 'platform',
        businessInfo: {
          price: newV,
          adsource: getSource(),
        },
      });
    },
  },
  async created() {
    document.title = '超级会员';
    if (window.history && window.history.pushState && env.isEasyBikeApp) {
      window.history.pushState(null, '挽留弹窗', document.URL);
      window.addEventListener('popstate', this.handleBack, false); // false阻止默认事件
      const { token } = await getTokenAndKey({ force: true });
      if (token) {
        this.getData();
        this.getWaitPayOrder();
      }
      this.willRetain = true;
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_sideslip',
        categoryId: 'platform',
        businessInfo: {},
      });
    }
    Storage.removeItem('isNoSign');
    const {
      finishPay, loopIntervalSecond,
      orderNo,
      loopTotalSecond,
    } = ParamsUtil.getParams(window.location.href);
    const { token } = await getTokenAndKey();
    if (finishPay) {
      this.searchStatus({
        loopIntervalSecond,
        orderNo,
        loopTotalSecond,
        token,
      }, null);
    }
    this.getTaskCode();
  },
  mounted() {
    document.title = '超级会员';
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    // this.initCashier();
    this.getData();
    // this.getWaitPayOrder();
    if (!env.isEasyBikeApp) {
      this.topStyle = 'margin-top:-0.44rem';
    }
  },
  destroyed() {
    if (this.willRetain && env.isEasyBikeApp) {
      window.removeEventListener('popstate', this.handleBack, false); // false阻止默认事件
    }
    this.closeBuyTime = null;
  },
  methods: {
    openNbaModal(data) {
      this.nbaShow = true;
      this.nbaPrice = {
        ...this.price,
        ...data,
        current: data.price,
        original: data.markedPrice,
      };
    },
    showError() {
      this.haveData = false;
    },
    getChooseIndex(val) {
      this.chooseIndex = val;
    },
    getAggData(val) {
      const goodsObj = { goodsList: [val] };
      this.vipData = goodsObj;
      this.price.current = val.price;
      this.price.goodsGuid = val.goodsGuid;
      this.save = `${val.propTotalAmount}`;
      this.centerTitleLift = val.centerTitleLift;
      this.price.original = val.markedPrice;
      this.price.couponEndTime = val.couponEndTime;
      this.price.showPopUpWindowType = val.showPopUpWindowType;
      this.price.signInfoDTO = val.signInfoDTO;
      this.transPrice = val.signInfoDTO ? val.signInfoDTO.firstSignPrice || '-' : '-';
      this.fullRefundUnusedShowAb = val.fullRefundUnusedShowAb;
      this.unOpenCouponGameAB = val.unOpenCouponGameAB || false; // 未开卡页券玩法
      this.propVersion = val.propVersion;
      this.currentRideCard = val.currentRideCard;
      this.autoRenewalStatus = val.autoRenewalStatus;
      this.taurusTaskUnOpenShowSort = val.taurusTaskUnOpenShowSort;
      this.unOpenCouponGameAB = val.unOpenCouponGameAB || false;
      this.commonBonus = val.commonBonus;
      if (this.commonBonus) {
        this.otherList = this.commonBonus.filter((i) => i.bonusEntity.unPayImage !== '' && i.bonusEntity.unPayImage);
      }
      // this.showStyleVersion = null;
      this.checkShowQa(val.goodsGuid);
      if (val.moduleInfos) {
        const tempGiftList = val.moduleInfos.filter((i) => i.moduleCode === 'openCeremony');
        if (tempGiftList.length > 0 && tempGiftList[0].moduleData) {
          this.giftList = tempGiftList[0].moduleData.bonus;
        } else {
          this.giftList = [];
        }
      } else {
        this.giftList = [];
      }
    },
    goSuggest() {
      this.showFeedback = true;
    },
    async feedbackSubmit(point, info) {
      const { token } = await getTokenAndKey();
      await submitFeedback({
        token,
        point,
        info,
        systemCode: getSystemCode(),
        scene: 'propFeedBack',
      })
        .then((res) => {
        // 由于无res和code=103时都会走then，所以仅code=0 case为成功 关闭popup。
          if (res) {
            if (res.code === 0) {
              this.showFeedback = false;
              this.closeScroll();
              Toast.show('提交成功，感谢反馈');
            } else {
              Toast.showError(res.msg);
            }
          }
        })
        .catch((e) => Toast.showError(e));
    // this.isShowFeedbackRequest();
    },
    getTaskCode() {
      clientSDK().get('task_code', null).then((res) => {
        if (res) {
          this.taskCode = res.taskCode;
        }
      });
    },
    showNoUse() {
      this.showNoUseBolck = true;
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_refund',
        categoryId: 'platform',
        businessInfo: {},
      });
      UBT.moduleExpose({
        pageId: 'platform_savemoneycard_page',
        categoryId: 'platform',
        moduleId: 'platform_refund_rule',
        contentId: 'platform_refund_rule',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    goUrl(url = this.config.deepLink, download = false) {
      this.goCardComplete();
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      if (env.isWeixin || env.isWechatMini) {
        window.location.href = (this.config.wechatLink);
        return;
      }
      window.location.href = url;
    },
    priceChange(val) {
      if (val === 1) {
        this.zeroBuyCardShow = true;
      } else {
        this.zeroBuyCardShow = false;
      }
    },
    getSignleImg(index) {
      if (this.zeroBuyCardShow) {
        return `特权${2 + index}`;
      }
      if (this.goodsList.length < 2) {
        if (this.goodsList[0].propVersion.includes('ride')) {
          return `特权${3 + index}`;
        }
        return `特权${2 + index}`;
      }
      // if (this.goodsList[this.ladderTab].propVersion === 'ride_trial') {
      //   return '特权2';
      // }
      if (this.goodsList[this.ladderTab].propVersion.includes('ride')) {
        return `特权${3 + index}`;
      }
      if (this.goodsList[this.ladderTab].propVersion.includes('ladder')) {
        return `特权${2 + index}`;
      }
      return `特权${3 + index}`;
    },
    getImgIcon(val) {
      if (this.propVersion === 'ladder') {
        return this.groupsImg[val - 1];
      }
      return this.groupsImg[val];
    },
    readOk() {
      this.isRead = true;
      if (this.price.showPopUpWindowType !== 1) {
        let openPrice;
        if (this.transType === 30 || this.transType === 110) {
          if (this.isNba) {
            // eslint-disable-next-line no-nested-ternary
            openPrice = this.nbaPrice.signInfoDTO ? (this.nbaPrice.signInfoDTO.firstSignPrice >= 0 ? this.nbaPrice.signInfoDTO.firstSignPrice : '-') : '-';
          } else {
            // eslint-disable-next-line no-nested-ternary
            openPrice = this.price.signInfoDTO ? (this.price.signInfoDTO.firstSignPrice >= 0 ? this.price.signInfoDTO.firstSignPrice : '-') : '-';
          }
        } else if (this.transType === 60) {
          openPrice = 0;
        } else if (this.isNba) {
          openPrice = (this.nbaPrice.current >= 0 ? this.nbaPrice.current : '-');
        } else {
          openPrice = (this.price.current >= 0 ? this.price.current : '-');
        }
        this.bayCardHandler(null, this.transType, openPrice, this.payChannel, this.planId, this.isNba, this.payActivityInfo);
      } else {
        this.openDialog();
      }
    },
    openRead(payChannel = '', planId = '', isNba, payActivityInfo = {}) {
      this.payChannel = payChannel;
      this.planId = planId;
      this.isRead = false;
      this.showRead = true;
      this.isNba = isNba;
      this.payActivityInfo = payActivityInfo;

    // this.isRead = false;
    // this.showRead = true;
    // this.readOk();
    },
    closeScroll() {
      getNoScroll(false);
    },
    goSecond(index) {
      if (index < 3) {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: `platform_coupon${index + 2}`,
          categoryId: 'platform',
          businessInfo: {},
        });
      }
    },
    async checkShowQa(val) {
      const { token } = await getTokenAndKey();
      let tempGoodsId;
      if (val) {
        tempGoodsId = val;
      } else if (this.showStyleVersion === 'ladderEasy') {
        tempGoodsId = this.goodsList[this.ladderTab].goodsGuid;
      } else {
        tempGoodsId = this.price.goodsGuid;
      }

      try {
        const res = await showQa({
          token,
          action: 'aries.vip.qa.get',
          goodsGuid: tempGoodsId,
        });
        if (res.data) {
          this.showQa = true;
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_QA_membership',
            contentId: 'platform_QA_membership',
            exposureTimes: 1,
            businessInfo: {
              membership_version: this.propVersion === 'normal' ? '1' : '2',
              BusinessLine: res.data.appCode,
            },
          });
        } else {
          this.showQa = false;
        }
      } catch (e) {
      // eslint-disable-next-line no-console
        console.log('e', e);
        this.showQa = false;
      }
    },
    goQa() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_QA_membership',
        categoryId: 'platform',
        businessInfo: {},
      });
      Navigator.go(`https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env === 'dev' ? 'fat' : config.env}/`}latest/index.html#/vip/super/components/qa?goodsGuid=${this.price.goodsGuid}`);
    },
    openCommonBonus(value, boolean, num) {
      if (boolean) {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: `platform_model${num + 2}`,
          categoryId: 'platform',
          businessInfo: {},
        });
      } else {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: 'platform_Quick_navigation_detail',
          categoryId: 'platform',
          businessInfo: {},
        });
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_Quick_navigation_detail',
          contentId: 'platform_Quick_navigation_detail',
          exposureTimes: 1,
          businessInfo: {},
        });
      }

      this.$refs.onepageup.open(value);
      getNoScroll(true);
    },
    getBigMoney(value) {
      return parseInt(value, 10);
    },
    getSmallMoney(value) {
      if (value % 1 === 0) {
        return '';
      }
      return `${value.toString().substring(value.toString().indexOf('.'), value.length)}`;
    },
    getTransTab(type, price) {
      this.transType = type;
      if (this.transType !== 60) {
        if (price >= 0 && price !== '-') {
          this.transPrice = price;
        }
      } else {
        this.transPrice = 0;
      }
    },
    openDialog() {
      this.getWaitPayOrder();
    },
    async cancel() {
      const { token } = await getTokenAndKey();
      try {
        await closeVipGoods({
          token,
          action: 'aries.vip.order.closeVipGoods',
          orderNo: this.noPayData.orderNo,
        });
      // Toast.show('取消成功');
      // await this.getData();
      } catch (e) {
        Toast.showError(e);
      }
    },
    async getWaitPayOrder() {
      const { token } = await getTokenAndKey();
      try {
        const res = await getWaitPayOrder({
          token,
          action: 'aries.vip.order.getWaitPayOrder',
        });
        if (res.data) {
          this.noPayData = res.data;
          UBTUtils.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_pay_Popup',
            contentId: 'platform_pay_Popup',
            exposureTimes: 1,
            businessInfo: {},
          });
          // this.showNopay = true;
          await this.cancel();
        } else {
        // this.showNopay = false;
        }
      } catch (e) {
        Toast.showError(e);
      }
    },
    refreshNopay() {
      this.showNopay = false;
      this.getData();
    },
    closeNew() {
      this.showNopay = false;
    },
    async getData() {
      const isLogin = await Native.isLogin();
      if (!isLogin) {
        this.handleButton();
        return;
      }
      const { token, cityCode } = await getTokenAndLocation();
      const { data } = await getSuperVipGoods({
        token,
        cityCode,
        systemCode: getSystemCode(),
        adsource: ParamsUtil.getParam('adsource'),
      }).catch(() => ({}));
      if (!data) {
        this.handleButton();
        return;
      }

      const {
        groupList = [],
        propVersion,
        unOpenShowCanBuy,
        newCustomer,
        goodsList,
        showStyleInfo,
      } = data;
      this.vipData = data;
      this.unOpenShowCanBuy = unOpenShowCanBuy;
      this.newCustomer = newCustomer;
      this.goodsList = goodsList;
      if (showStyleInfo) {
        this.bikeCardShowStyle = showStyleInfo.bikeCardShowStyle;
      }
      const promises = this.goodsList.map(async (x, index) => {
        if (x.propVersion === 'ladder') {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_copuon_card',
            contentId: 'platform_copuon_card',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        if (x.aggCategory && x.aggCategory === 'goods_agg') {
          const aggGood = await this.getAggGoods(x.aggCategory, x.propVersion);
          // this.goodsList[index] = JSON.parse(JSON.stringify({ ...x, ...aggGood }));
          this.$set(this.goodsList, index, JSON.parse(JSON.stringify({ ...x, ...aggGood })));
        }
      });

      // 等待所有异步操作完成
      await Promise.all(promises);
      this.checkShowQa();
      this.groupList = groupList;
      this.getBack();
      if (propVersion !== 'normal') {
        let tempMapList;
        if (Array.isArray(goodsList) && goodsList.length >= 1) {
          goodsList.forEach((x) => {
            if (x.ladderPropGroupList) {
              tempMapList = x.ladderPropGroupList;
            }
          });
        }
        if (tempMapList) {
          this.ladderPropGroupList = filterNoOpenData(tempMapList, this.propVersion);
        } else {
          this.ladderPropGroupList = [];
        }
      }
      let goods = null;
      if (goodsList && Array.isArray(goodsList)) {
      // if() {

        // }else {

        // }
        goods = goodsList[this.ladderTab];
        this.cardPurchaseSuggestionDTO = goods.cardPurchaseSuggestionDTO;
        if (!this.cardPurchaseSuggestionDTO) {
          let version = '';
          if (goods.propVersion.includes('ride')) {
            version = '单车';
          }
          if (goods.propVersion.includes('ebike')) {
            version = '助力车';
          }
          if (goods.propVersion.includes('ladder')) {
            version = '打车';
          }
          this.cardPurchaseSuggestionDTO = {
            tagSuggestion: '不错选择',
            verbalTrick: `不错选择，使用${version}出行很划算`,
            highlight: '',
            icon: 'https://m.hellobike.com/resource/gallery/61/VBLOz8WU7v.png?x-oss-process=image/quality,q_80',
          };
        }
        this.buyingAdviceAB = goods.buyingAdviceAB;
        if (goods.aggCategory) {
        // goods = await this.getAggGoods(goods.aggCategory, goods.propVersion);
        // goods = await goods.goodsList[this.a];
          const tempArr = this.aggList.filter((i) => i.propVersion === this.anchoredVersion);
          if (tempArr && tempArr.length >= 1) {
          // eslint-disable-next-line prefer-destructuring
            goods = tempArr[0];
            const goodsObj = { goodsList: [goods] };
            this.vipData = goodsObj;
          }
        } else {
          goods = goodsList[this.ladderTab];
        }
        this.price.current = goods.price;
        this.price.goodsGuid = goods.goodsGuid;
        this.save = `${goods.propTotalAmount}`;
        this.centerTitleLift = goods.centerTitleLift;
        this.price.original = goods.markedPrice;
        this.price.couponEndTime = goods.couponEndTime;
        this.price.showPopUpWindowType = goods.showPopUpWindowType;
        this.price.signInfoDTO = goods.signInfoDTO;
        this.transPrice = goods.signInfoDTO ? goods.signInfoDTO.firstSignPrice || '-' : '-';
        this.fullRefundUnusedShowAb = goods.fullRefundUnusedShowAb;
        this.unOpenCouponGameAB = goods.unOpenCouponGameAB || false; // 未开卡页券玩法
        this.signPayChannels = goods.signPayChannels || [];
        if (this.fullRefundUnusedShowAb) {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_refund',
            contentId: 'platform_refund',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        if (goods.moduleInfos && Array.isArray(goods.moduleInfos)) {
          const tempGiftList = goods.moduleInfos.filter((i) => i.moduleCode === 'openCeremony');
          if (tempGiftList.length > 0 && tempGiftList[0].moduleData) {
            this.giftList = tempGiftList[0].moduleData.bonus;
          } else {
            this.giftList = [];
          }
        } else {
          this.giftList = [];
        }
        this.commonBonus = goods.commonBonus;
        this.autoRenewalStatus = goods.autoRenewalStatus;
        this.taurusTaskUnOpenShowSort = goods.taurusTaskUnOpenShowSort;
        this.ladderDetailMap = goods.ladderDetailMap || {};
        this.propVersion = goods.propVersion;
        this.currentRideCard = goods.currentRideCard;
        this.zeroBuyCardShow = !!this.currentRideCard;
        if (this.zeroBuyCardShow) {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_0yuan_button',
            contentId: 'platform_0yuan_button',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      }
      if (this.autoRenewalStatus === RENEWAL_STATUS.unavailable) {
        this.transType = 0;
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_nochoosebutton',
          contentId: 'platform_nochoosebutton',
          exposureTimes: 1,
          businessInfo: {
            typeandprice: `2&${this.price.current}`,
          },
        });
      } else {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_type_choose',
          contentId: 'platform_type_choose',
          exposureTimes: 1,
          businessInfo: {
            typeandprice: `1&${this.price.signInfoDTO ? this.price.signInfoDTO.firstSignPrice : null};2&${this.price.current}`,
          },
        });
      }
      let tempList = [];
      tempList = goods.groupList;

      if (tempList) {
        this.groups = await filterNoOpenData(tempList, this.propVersion);
      }
      [this.groupsOne, ...this.groupsOther] = this.groups;


      this.groupsOther.forEach((i, index) => {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: `platform_coupon${index + 1}`,
          contentId: `platform_coupon${index + 1}`,
          exposureTimes: 1,
          businessInfo: {},
        });
      });
      if (this.commonBonus) {
        this.otherList = this.commonBonus.filter((i) => i.bonusEntity.unPayImage !== '' && i.bonusEntity.unPayImage);
      }
      if (this.otherList) {
        this.otherList.forEach((i, index) => {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: `platform_model${index + 1 + this.groupsOther.length}`,
            contentId: `platform_model${index + 1 + this.groupsOther.length}`,
            exposureTimes: 1,
            businessInfo: {},
          });
        });
      }

      if (
        this.taurusTaskUnOpenShowSort === '2'
        && this.showStyleVersion !== 'ladderEasy'
      ) {
      // eslint-disable-next-line prefer-destructuring
        this.testSecondList = this.otherList[0];
        this.testSecondList.length = 1;
      // this.otherList.splice(0, 1);
      }
      this.haveData = true;
      this.handleButton();
    },
    // eslint-disable-next-line consistent-return
    async getAggGoods(aggCategory, propVersion) {
      const { token, cityCode } = await getTokenAndLocation();
      try {
        const res = await aggGoods({
          token,
          aggCategory,
          aggVersion: propVersion,
          cityCode,
        });
        this.aggList = res.data.goodsList;
        this.anchoredVersion = res.data.anchoredVersion;
        // eslint-disable-next-line prefer-destructuring
        if (this.aggList && this.aggList.length) {
          const tempArr = this.aggList.filter((i) => i.propVersion === this.anchoredVersion);
          if (tempArr && tempArr.length > 0) {
          // eslint-disable-next-line prefer-destructuring
            this.chooseObj = tempArr[0];
          // await this.$emit('aggData', this.chooseObj);
          // this.getAggData(this.chooseObj);
          }
        }
        // this.aggCardList = res.data.goodsList.map((i) => ({
        //   ...i.mainPropertyDetail,
        //   propVersion: i.propVersion,
        // }));
        return res.data;

      // eslint-disable-next-line no-empty
      } catch (error) {
        return {};
      }
    },
    getBack() {
      let filterList = [];
      let isAppVip; // app膨胀卡版
      filterList = this.goodsList.filter((x) => x.propVersion.includes('app'));
      if (filterList.length > 0) {
        isAppVip = true;
      } else {
        isAppVip = false;
      }
      this.isAppVip = isAppVip;
      if (
        this.newCustomer
        && env.isEasyBikeApp
      ) {
        this.topStyle = 'padding-top: 0.98rem;background-image: url(https://m.hellobike.com/resource/helloyun/22871/1cCZc0TdI5.png);';
      }
      if (
        this.newCustomer
        && !env.isEasyBikeApp
        && isAppVip
      ) {
        this.topStyle = 'padding-top: 0rem; background-image: url(https://m.hellobike.com/resource/helloyun/22871/bb-e4d0h_Z.png);';
        this.showAppExpensive = true;
      }
      if (
        !this.newCustomer
        && env.isEasyBikeApp
      ) {
        this.topStyle = 'padding-top: 0.98rem;background-image: url(https://m.hellobike.com/resource/helloyun/22871/NEiysKJuXt.png?x-oss-process=image/quality,q_80);';
      }
      if (
        !env.isEasyBikeApp
        && !isAppVip
      ) {
        this.topStyle = 'padding-top: 0rem; background:linear-gradient(to bottom, #FCE489 1.3rem, #fcfdfd 0.5rem, #f0f4f7 100%);';
      }
      if (
        !this.newCustomer
        && !env.isEasyBikeApp
        && isAppVip
      ) {
        this.topStyle = 'padding-top: 0rem; background-image: url(https://m.hellobike.com/resource/helloyun/22871/bb-e4d0h_Z.png);';
        this.showAppExpensive = true;
      }
      if (this.buyingAdviceAB && env.isEasyBikeApp) {
        this.topStyle = 'padding-top: 0.98rem; background-image: url(https://m.hellobike.com/resource/gallery/61/bWaybRk-TA.png?x-oss-process=image/quality,q_80)';
      }
    },
    async changeLadderEasy(val) {
      this.ladderTab = val;
      if (this.showStyleVersion === 'ladderEasy') {
        let currentGoods = this.goodsList[this.ladderTab];
        if (currentGoods.commonBonus) {
          this.otherList = currentGoods.commonBonus.filter(
            (i) => i.bonusEntity.unPayImage,
          );
        }
        if (this.fullRefundUnusedShowAb) {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_refund',
            contentId: 'platform_refund',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        this.cardPurchaseSuggestionDTO = currentGoods.cardPurchaseSuggestionDTO;
        if (!this.cardPurchaseSuggestionDTO) {
          let version = '';
          if (currentGoods.propVersion.includes('ride')) {
            version = '单车';
          }
          if (currentGoods.propVersion.includes('ebike')) {
            version = '助力车';
          }
          if (currentGoods.propVersion.includes('ladder')) {
            version = '打车';
          }
          this.cardPurchaseSuggestionDTO = {
            tagSuggestion: '不错选择',
            verbalTrick: `不错选择，使用${version}出行很划算`,
            highlight: '',
            icon: 'https://m.hellobike.com/resource/gallery/61/VBLOz8WU7v.png?x-oss-process=image/quality,q_80',
          };
        }
        this.buyingAdviceAB = currentGoods.buyingAdviceAB;
        if (currentGoods.aggCategory) {
          const tempArr = currentGoods.goodsList.filter((i) => i.propVersion === this.anchoredVersion);
          if (tempArr && tempArr.length >= 1) {
          // eslint-disable-next-line prefer-destructuring, no-undef
            currentGoods = tempArr[0];
            const obj = { goodsList: [tempArr[0]] };
            this.vipData = obj;
          } else {
            currentGoods = this.goodsList[this.ladderTab];
            const obj = { goodsList: [this.goodsList[this.ladderTab]] };
            this.vipData = obj;
          }
        // // eslint-disable-next-line prefer-destructuring
        // currentGoods = await currentGoods.goodsList[0];
        } else {
          currentGoods = this.goodsList[this.ladderTab];
          const obj = { goodsList: [this.goodsList[this.ladderTab]] };
          this.vipData = obj;
        }
        this.fullRefundUnusedShowAb = currentGoods.fullRefundUnusedShowAb;
        this.commonBonus = currentGoods.commonBonus;
        this.price.current = currentGoods.price;
        this.price.goodsGuid = currentGoods.goodsGuid;
        this.save = `${currentGoods.propTotalAmount}`;
        this.centerTitleLift = currentGoods.centerTitleLift;
        this.price.original = currentGoods.markedPrice;
        this.price.couponEndTime = currentGoods.couponEndTime;
        this.price.showPopUpWindowType = currentGoods.showPopUpWindowType;
        this.price.signInfoDTO = currentGoods.signInfoDTO;
        this.transPrice = currentGoods.signInfoDTO ? currentGoods.signInfoDTO.firstSignPrice || '-' : '-';
        this.ladderDetailMap = currentGoods.ladderDetailMap || {};
        this.propVersion = currentGoods.propVersion;
        this.currentRideCard = currentGoods.currentRideCard;
        this.autoRenewalStatus = currentGoods.autoRenewalStatus;
        this.taurusTaskUnOpenShowSort = currentGoods.taurusTaskUnOpenShowSort;
        this.signPayChannels = currentGoods.signPayChannels || [];
        this.unOpenCouponGameAB = currentGoods.unOpenCouponGameAB || false;
        if (currentGoods.moduleInfos) {
          const tempGiftList = currentGoods.moduleInfos.filter((i) => i.moduleCode === 'openCeremony');
          if (tempGiftList.length > 0 && tempGiftList[0].moduleData) {
            this.giftList = tempGiftList[0].moduleData.bonus;
          } else {
            this.giftList = [];
          }
        } else {
          this.giftList = [];
        }

        if (this.buyingAdviceAB && env.isEasyBikeApp) {
          this.topStyle = 'padding-top: 0.98rem; background-image: url(https://m.hellobike.com/resource/gallery/61/bWaybRk-TA.png?x-oss-process=image/quality,q_80)';
        } else {
          this.getBack();
        }
        this.zeroBuyCardShow = !!this.currentRideCard;
        const tempList = currentGoods.groupList;
        if (tempList) {
          this.groups = filterNoOpenData(tempList, this.propVersion);
        }
        [this.groupsOne, ...this.groupsOther] = this.groups;

        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_type_choose',
          contentId: 'platform_type_choose',
          exposureTimes: 1,
          businessInfo: {
            typeandprice: `1&${this.price.signInfoDTO ? this.price.signInfoDTO.firstSignPrice : null};2&${this.price.current}`,
          },
        });
        this.checkShowQa(this.price.goodsGuid);
        this.$forceUpdate();
      }
    },
    handleButton() {
      this.$nextTick(() => {
        let btn = null;
        if (this.autoRenewalStatus === RENEWAL_STATUS.unavailable) {
          btn = this.$refs.button;
        } else {
          btn = this.$refs.buttonNew;
        }
        if (btn) {
        // btn.locate();
        // this.$nextTick(() => {
        //   const { classes } = btn;
        //   if (classes && classes.fixed) {
        //     this.groupsClass.radius = true;
        //   }
        // });
        }
      });
    },
    handleBack() {
      if (this.$refs.retain && this.save && this.save !== '-') {
        this.$refs.retain.open();
        getNoScroll(true);
      }
    },
    async bayCardHandler(val, num, money, payChannel = '', planId = '', isNba, payActivityInfo = {}) {
      if (this.payingFlag) {
        Toast.show('正在支付中，请稍候');
        return;
      }
      this.payChannel = payChannel;
      this.planId = planId;
      this.payActivityInfo = payActivityInfo;
      const { token, cityCode, adCode } = await getTokenAndLocation();
      if (!token) {
        Toast.show('请先登录');
        return;
      }
      let tempMoney = null;
      if (num === 30 || num === 60 || num === 110) {
        tempMoney = money;
      } else if (isNba) {
        tempMoney = this.nbaPrice.current;
      } else {
        tempMoney = this.price.current;
      }
      const toPost = {
        cityCode,
        adCode,
        token,
        ...(isNba ? this.nbaPrice : this.price || {}),
        ...{
          price: tempMoney,
        },
        systemCode: getSystemCode(),
        orderOptType: num || 0, // 0：用户正常下单；10:手动续费下单； 30:连续包月下单
      };
      if ((num === 30 || num === 60) && !toPost.price) {
        CardService.signWithoutPasswordContract().then(() => this.buyGoods(num, toPost, val));
      } else {
        this.buyGoods(num, toPost, val);
      }
    },
    buyGoods(num, toPost, val) {
      if (this.payingFlag) {
        Toast.show('正在支付中，请稍候');
        return;
      }
      this.payingFlag = true;
      buyVipGoods(toPost)
        .then(async (v) => {
          const { token } = await getTokenAndLocation();
          if (v && v.data) {
            const {
              loopIntervalSecond,
              orderNo,
              loopTotalSecond,
              showPopUpWindowType, // ？
            } = v.data;
            if (env.isWechatMini) {
              if (num === 30) {
              // 连续包月
                if (showPopUpWindowType === 1) {
                  await this.getWaitPayOrder();
                  this.payingFlag = false;
                  setTimeout(() => {
                    this.buyGoods(num, toPost, val);
                  }, 10);
                  return;
                }
                await CardService.evokePageAndSign(v.data, this.planId);
                this.nbaShow = false;
                return;
              }
              // 直接买一个月
              window.location.href = ParamsUtil.addParams(window.location.href, {
                loopIntervalSecond,
                orderNo,
                loopTotalSecond,
              });
            }
            if (showPopUpWindowType === 1 && (!val || val === 0)) {
              await this.getWaitPayOrder();
              // this.closeBuyTime = setTimeout(async () => {
              this.payingFlag = false;
              setTimeout(() => {
                this.buyGoods(num, toPost, val);
              }, 10);
            // }, 1500);
            } else if (toPost.price) {
            // eslint-disable-next-line no-lonely-if
              if (num !== 30 && num !== 110 && this.propVersion !== PropVersionMap.RIDE_ONE_CENT) {
                if (toPost.price) {
                  setTimeout(() => {
                    this.payingFlag = false;// 由于buy方法未推进promise状态 拉起比较迅速 所以直接置为没正在支付
                  }, 1000);
                  await CardService.buyMember(v.data)
                    .then(() => {
                      this.searchStatus(
                        {
                          token,
                          orderNo,
                          loopIntervalSecond,
                          loopTotalSecond,
                        },
                        num,
                      );
                      this.nbaShow = false;
                    })
                    .catch((e) => {
                      if (e) {
                        Toast.showError(e);
                      }
                    });
                } else {
                  this.searchStatus(
                    {
                      token,
                      orderNo,
                      loopIntervalSecond,
                      loopTotalSecond,
                    },
                    num,
                  );
                  this.nbaShow = false;
                }
              } else if (!env.isEasyBikeApp
                && !env.isAlipayBrowser && !env.isAliMP && !env.isWechatMini) {
                const queryRedirectUrl = `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/index.html#/vip/v2/transfer`;
                const baseQuery = `redirectUrl=${encodeURIComponent(
                  queryRedirectUrl,
                )}&h5Login=1`;
                const schemeQuery = config.env === 'fat' ? baseQuery : `codeEnv=${config.env}&${baseQuery}`;
                const scheme = `alipays://platformapi/startapp?appId=2017050407110255&page=/pages/index/index&query=${encodeURIComponent(
                  schemeQuery,
                )}`;
                window.location.href = scheme;
              } else {
                let data = { ...v.data };
                if (this.propVersion === PropVersionMap.RIDE_ONE_CENT) {
                  // 一分骑走抖音签约,抖音签约参数
                  const isContinuous = [ORDER_TYPE.CONTINUOUS_MONTHLY, ORDER_TYPE.UNION_CONTINUOUS_MONTH].includes(num);
                  const channel = isContinuous ? '2309' : '2304';
                  const extension = isContinuous
                    ? {
                      planId: '', // 无需传planId，就会有兜底planId
                      signMustPay: true,
                      attachSceneType: 'RIDE',
                    }
                    : {
                      signMustPay: true,
                    };
                  const { productTagForDySign = '', bizScene = '' } = this.payActivityInfo || {};
                  data = {
                    ...v.data,
                    channelOperationInfoExt: {
                      productTagForDySign,
                      biz_scene: bizScene,
                    },
                    channel,
                    extension,
                  };
                } else if (this.payChannel) {
                  data.signChannel = this.payChannel;
                  if (this.planId || env.isWeixin || env.isWechatMini) {
                    data.extension = {};
                    data.extension.planId = this.planId;
                  }
                }
                await CardService.buyContinueMember(data)
                  .then(() => {
                    this.searchStatus(
                      {
                        token,
                        orderNo,
                        loopIntervalSecond,
                        loopTotalSecond,
                      },
                      num,
                    );
                    this.nbaShow = false;
                  })
                  .catch((e) => {
                    if (e) {
                      Toast.showError(e);
                    }
                  });
              }
            } else {
              this.searchStatus(
                {
                  token,
                  orderNo,
                  loopIntervalSecond,
                  loopTotalSecond,
                },
                num,
              );
              this.nbaShow = false;
            }
          }
        })
        .catch((e) => {
          Toast.showError(e);
          this.getData();
        })
        .finally(() => {
          this.payingFlag = false;
        });
    },
    // 轮询付费会员状态
    async searchStatus({
      token, orderNo, loopIntervalSecond = 1, loopTotalSecond = 5,
    }) {
      // loopIntervalSecond 轮询间隔时间
      // loopTotalSecond 轮询总时间
      // 重置计数器
      this.curloopIntervalSecond = 0;

      const poll = async () => {
        if (this.curloopIntervalSecond >= loopTotalSecond) {
          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = null;
          }
          return;
        }

        try {
          const { data, msg } = await tryTakeOrderStatus({
            token,
            orderNo,
            systemCode: getSystemCode(),
          });
          if (data) {
            const { status } = data;

            // 订单交易中
            if (status === ORDER_STATUS.padding) {
              this.curloopIntervalSecond += loopIntervalSecond;
              this.orderTimer = setTimeout(poll, loopIntervalSecond * 1000);// 更新timer
              return;
            }

            // 清除定时器
            if (this.orderTimer) {
              clearTimeout(this.orderTimer);
              this.orderTimer = null;
            }

            UBT.clickButton({
              pageId: 'platform_PurchasePage',
              buttonName: 'platform_ToPurchase',
              categoryId: 'platform',
              businessInfo: {
                adsource: getSource(),
                TransactionResults: (() => {
                  if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
                    return 0;
                  }
                  if (status === ORDER_STATUS.success) {
                    return 1;
                  }
                  return '';
                })(),
              },
            });

            // 订单成功
            if (status === ORDER_STATUS.success) {
              if (!this.showAppExpensive) {
                this.$refs.complete.open();
              } else {
                this.showAppPrivilege = true;
                UBT.moduleExpose({
                  pageId: 'platform_openedcard_page',
                  categoryId: 'platform',
                  moduleId: 'platform_VIPappPOP',
                  contentId: 'platform_VIPappPOP',
                  exposureTimes: 1,
                  businessInfo: {},
                });
              }
            }

            // 订单失败
            if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
              Toast.show('正在支付中，请稍候查看');
              this.$router.go(-1);
            }
          } else {
            // API 调用失败，停止轮询
            if (this.orderTimer) {
              clearTimeout(this.orderTimer);
              this.orderTimer = null;
            }
            Toast.show(msg);
          }
        } catch (error) {
          // 处理异常，停止轮询
          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = null;
          }
          Toast.show('查询订单状态失败');
        }
      };

      // 开始轮询
      this.orderTimer = setTimeout(poll, loopIntervalSecond * 1000);
    },
    goCardComplete() {
      getNoScroll(false);
      this.$router.replace({
        path: '/vip/v2',
        query: { isComplete: true },
      });
    },
    goBack() {
      Native.closeWebView();
    },
    rule() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_buycardrecord',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      window.onpageshow = null;
      Navigator.go('https://m.hellobike.com/mf/spa/u_jsawic/latest/MA2112242694445671692369920.html?activityCode=MA2112242694445671692369920');
    },
  },
};
</script>

<style lang="less" scoped>
.super-container {
  background: #f4f4f4;
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;
  padding-top: 1.06rem;

  .header {
    .top-left-line {
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/Ylp78_logo%202.png?x-oss-process=image/format,webp);
      background-size: 100% 100%;
      width: 1.05rem;
      height: 0.18rem;
      margin-top: 0.03rem;
    }

    .middle-img {
      img {
        width: 1.45rem;
        height: 0.2rem;
      }
    }

    .header-menu {
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/x4P3I_Slice%206.png?x-oss-process=image/format,webp);
      background-size: 100% 100%;
      width: 0.83rem;
      height: 0.24rem;
      margin-top: 0.03rem;
    }
  }

  .haveData {
    .ladder-have-test {
      .ladder-tab {
        height: 0.5rem;
        width: 100%;
        background: red;
      }

      .bikeMonthCard {
        width: 3.51rem;
        height: 1.3rem;
        background: url(https://m.hellobike.com/resource/helloyun/wb26923/VAewHezZY1.png?x-oss-process=image/quality,q_80);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        margin: 0.03rem auto;

        .card-top {
          display: flex;
          align-items: center;
          height: 0.44rem;

          .icon {
            width: 0.57rem;
            height: 0.18rem;
            margin-left: 0.15rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .text {
            font-size: 0.15rem;
            color: #242729;
            margin-left: 0.05rem;
            font-weight: 500;
          }
        }

        .card-bottom {
          width: 3.21rem;
          height: 0.72rem;
          background: url(https://m.hellobike.com/resource/helloyun/wb26923/f2cSl_Rectangle%20106.png?x-oss-process=image/quality,q_80);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          margin: 0 auto;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;

          .left {
            float: left;
            padding-top: 0.17rem;
            padding-left: 0.16rem;
            display: flex;
            flex-direction: column;

            .topContext {
              font-size: 0.16rem;
              font-weight: 500;
              color: #5a6066;
            }

            .botContext {
              font-size: 0.12rem;
              color: #7d3b2a;
              margin-top: 0.03rem;
            }
          }

          .right {
            float: right;
            margin-top: 0.17rem;
            margin-right: 0.21rem;
            font-size: 0.14rem;

            .font {
              margin-left: -0.03rem;
              text-align: center;
              font-size: 0.26rem;
              color: #5a6066;
              margin-right: 0.03rem;
            }
          }
        }
      }

      .other-block-test {
        .other-block-item {
          margin: 0 0.12rem 0 0.12rem;
          position: relative;

          .other-title-img {
            position: absolute;
            top: 0.14rem;
            left: 0.15rem;

            .top-sign {
              background: linear-gradient(90deg, #76737c 0%, #36363c 100%);
              height: 0.18rem;
              border-radius: 0.1rem 0.02rem 0.1rem 0.02rem;
              color: #fffae8;
              font-size: 0.12rem;
              text-align: center;
              line-height: 0.18rem;
              padding: 0 0.05rem;
              margin-right: 0.05rem;
            }
          }

          .other-top-line {
            width: 100%;
            height: 0.46rem;
          }

          img.under-img {
            width: 100%;
          }
        }
      }

      .no-use {
        margin: 0.08rem 0.12rem 0.1rem 0.12rem;
        width: 3.51rem;
        height: 0.5rem;
        background: #fff;
        border-radius: 0.16rem;
        display: flex;
        justify-content: space-between;
        padding: 0.12rem 0.15rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.15rem;
        color: #242729;
        line-height: 0.26rem;
        border: 0.01rem solid #ebeef0;

        .no-use-left {
          display: flex;

          img.no-use-img {
            margin-right: 0.03rem;
            width: 0.26rem;
            height: 0.26rem;
          }
        }

        .no-use-right {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.14rem;
          color: #5a6066;

          img.no-use-flag {
            margin-left: 0.03rem;
            width: 0.1rem;
            height: 0.1rem;
          }
        }
      }

      .qa-and-suggest {
        display: flex;
        justify-content: space-around;
        margin: 0.08rem 0.12rem 0.2rem 0.12rem;
        height: 0.69rem;

        .suggest-block {
          background: #fff;
          border-radius: 0.12rem;
          padding: 0.14rem 0 0 0.12rem;
          height: 100%;
          width: 1.72rem;

          .suggest-title {
            font-family: PingFangSC-Medium, sans-serif;
            font-size: 0.16rem;
            color: #242729;
            font-weight: 500;
            margin-bottom: 0.05rem;
            display: flex;

            .qa-go {
              img {
                width: 0.15rem;
                height: 0.15rem;
              }
            }
          }

          .suggest-word {
            margin-top: 0.04rem;
            font-family: PingFangSC-Regular, sans-serif;
            font-size: 0.14rem;
            color: #879099;
            font-weight: 400;
          }
        }

        .qa-block {
          background: #fff;
          border-radius: 0.12rem;
          display: flex;
          justify-content: space-between;
          padding: 0.14rem 0 0 0.12rem;
          height: 100%;
          width: 1.71rem;

          .qa-left {
            .qa-title {
              font-family: PingFangSC-Medium, sans-serif;
              font-size: 0.16rem;
              color: #242729;
              font-weight: 500;
              margin-bottom: 0.05rem;
              display: flex;

              .qa-go {
                img {
                  width: 0.15rem;
                  height: 0.15rem;
                }
              }
            }

            .qa-word {
              margin-top: 0.04rem;
              font-family: PingFangSC-Regular, sans-serif;
              font-size: 0.14rem;
              color: #879099;
              font-weight: 400;
            }
          }
        }
      }

      .rule-block {
        text-align: center;
        width: 100%;
        margin: 0 auto;
        font-size: 0.13rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #879099;
        line-height: 0.18rem;
        padding-bottom: 0.28rem;
        background: #f0f4f7;
        margin-top: 0.15rem;
      }

      .shark-block {
        background: #f4f5f7;
        height: 2rem;
        width: 100%;
      }
    }
  }

  .no-scroll {
    overflow: hidden;
  }
}

.noData {
  height: 100vh;
  width: 100%;
  margin-top: -1rem;
  background: linear-gradient(#fffbeb, #fff);
  padding-top: 3.85rem;

  .noData-img {
    display: flex;
    justify-content: center;
    align-items: center;

    img.nodata-gif {
      margin: 0 auto;
      width: 0.4rem;
      height: 0.4rem;
    }
  }

  .noData-word {
    margin-top: 0.18rem;
    text-align: center;
    font-family: PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 500;
    line-height: 0.17rem;
    color: #879099;
  }
}
</style>
